module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.f7214668.svg";